<template>
  <div class="eni-toast-container">
    <transition-group name="eni-toast-fade" tag="div">
      <div
        v-for="item in list"
        :key="item.id"
        class="eni-toast"
        :class="'eni-toast-' + item.type"
      >
        <div class="eni-toast-icon">
          <span v-if="item.type === 'success'">✓</span>
          <span v-else-if="item.type === 'error'">✕</span>
          <span v-else-if="item.type === 'warn'">!</span>
          <span v-else>•</span>
        </div>

        <div class="eni-toast-content">
          <div class="eni-toast-title">{{ item.title }}</div>
          <div v-if="item.desc" class="eni-toast-desc">{{ item.desc }}</div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
let seed = 1;

export default {
  name: "TopToastHost",
  data() {
    return {
      list: []
    };
  },
  methods: {
    push(payload) {
      const id = seed++;

      const item = {
        id,
        ...payload
      };

      this.list.push(item);

      setTimeout(() => {
        this.remove(id);
      }, item.duration || 2600);
    },

    remove(id) {
      this.list = this.list.filter((i) => i.id !== id);
    },

    clear() {
      this.list = [];
    }
  }
};
</script>

<style scoped>
.eni-toast-container {
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

/* 主体 */
.eni-toast {
  min-width: 260px;
  max-width: 90vw;
  margin-bottom: 12px;
  padding: 14px 16px;
  border-radius: 16px;

  display: flex;
  align-items: center;
  gap: 12px;

  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);

  color: #fff;
  pointer-events: auto;

  animation: slideDown 0.25s ease;
}

/* 🎯 蓝色主风格 */
.eni-toast-info {
  background: linear-gradient(135deg, #3f86ff, #5fa8ff);
}

/* 成功（偏蓝绿） */
.eni-toast-success {
  background: linear-gradient(135deg, #2fcf8f, #4aaeff);
}

/* 警告 */
.eni-toast-warn {
  background: linear-gradient(135deg, #ffb020, #ff7a18);
}

/* 错误 */
.eni-toast-error {
  background: linear-gradient(135deg, #ff4d4f, #ff7a7a);
}

/* icon */
.eni-toast-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255,255,255,0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* 内容 */
.eni-toast-content {
  flex: 1;
}

.eni-toast-title {
  font-size: 14px;
  font-weight: 700;
}

.eni-toast-desc {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.9;
}

/* 动画 */
.eni-toast-fade-enter-active,
.eni-toast-fade-leave-active {
  transition: all 0.25s ease;
}

.eni-toast-fade-enter {
  opacity: 0;
  transform: translateY(-20px);
}

.eni-toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
}
</style>